import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '指标值限定',
    type: 'AMAR_IV_SCOPE',
    mapProp: 'map',
}